/** Unsaved task fields kept while a tutor visits the groove chooser. */
export interface PracticeTaskDraft {
  title: string;
  description: string;
  suggestedMinutes: string;
  repertoireId: string;
}

export function emptyPracticeTaskDraft(): PracticeTaskDraft {
  return { title: "", description: "", suggestedMinutes: "", repertoireId: "" };
}
